import { Home, Users, Bell, Wrench } from "lucide-react";
import { NavLink as RouterNavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useTasks } from "@/hooks/useTasks";
import { Badge } from "@/components/ui/badge";
import { isToday, isPast, parseISO } from "date-fns";
import { useAuth } from "@/contexts/AuthContext";
import { isRelationalManager, isBasicUser } from "@/lib/rbac";

const allNavItems = [
  { to: "/dashboard", icon: Home, label: "Home", rmVisible: true, basicVisible: true },
  { to: "/leads", icon: Users, label: "Leads", rmVisible: false, basicVisible: false },
  { to: "/tasks", icon: Bell, label: "Reminders", showBadge: true, rmVisible: true, basicVisible: true },
  { to: "/tools", icon: Wrench, label: "Tools", rmVisible: true, basicVisible: true },
];

export function MobileNav() {
  const { tasks } = useTasks();
  const { user } = useAuth();
  const isRM = isRelationalManager(user);
  const isBasic = isBasicUser(user);

  const navItems = allNavItems.filter(item =>
    (!isRM || item.rmVisible) && (!isBasic || item.basicVisible)
  );

  const urgentCount = tasks.filter(t => {
    if (t.completed || !t.dueDate) return false;
    if (!t.type || t.type === 'reminder') {
      const dueDate = typeof t.dueDate === 'string' ? parseISO(t.dueDate) : new Date(t.dueDate);
      return isToday(dueDate) || isPast(dueDate);
    }
    return false;
  }).length;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border/50 bg-card/98 backdrop-blur-xl md:hidden shadow-lg"
      style={{ paddingBottom: 'var(--safe-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around h-14">
        {navItems.map((item) => (
          <RouterNavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                "flex flex-col items-center justify-center gap-0.5 rounded-lg px-4 py-1.5 transition-all duration-200 min-w-[60px] relative",
                isActive ? "text-accent" : "text-muted-foreground hover:text-foreground"
              )
            }
          >
            {({ isActive }) => (
              <>
                <div className={cn("rounded-lg p-1.5 transition-all duration-200 relative", isActive && "bg-accent/10")}>
                  <item.icon className="h-5 w-5" />
                  {item.showBadge && urgentCount > 0 && (
                    <Badge className="absolute -top-1 -right-1 h-4 min-w-4 px-1 text-[9px] bg-red-500 text-white border-none">
                      {urgentCount}
                    </Badge>
                  )}
                </div>
                <span className="text-[10px] font-medium leading-none">{item.label}</span>
              </>
            )}
          </RouterNavLink>
        ))}
      </div>
    </nav>
  );
}